import { gql } from '@lcs/shared/api';

export const getScheduleQuery = gql`
   query GetSchedule($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      schedulesConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            scheduleId
            name
            description
            scheduleDetailsConnection {
               items {
                  dayOfWeek
                  openTime
                  closeTime
               }
            }
            closedExceptionsConnection {
               items {
                  startDate
                  endDate
                  startTime
                  endTime
                  promptId
               }
            }
            accountId
            createDate
            createUser {
               name
            }
            updateDate
            updateUser {
               name
            }
         }
      }
   }
`;
